import React, { useState, useCallback, useEffect, useRef } from 'react';
import { apiUrl, assetsUrl } from '../../config/Config';
import axios from 'axios';
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const TwitterCallback = () => {
    const { search } = useLocation();
    const [status, setStatus] = useState("Logging you in...");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userdata = useSelector((store) => store.userReducer.userdata);

    const getexchangetoken = async() => {
        const params = new URLSearchParams(search);
        const code = params.get("code");
        const state = params.get("state");
    
        if (!code) {
          setStatus("No code found in callback URL.");
          return;
        }

        var data = {
            'code' : code
        }
    
        // Send the code to backend for token exchange
        const headers = {
            headers: {
              Authorization: `Bearer ${userdata?.token}`,
            },
          };
      
          const res = await axios.post(apiUrl + "twitterlogin", data, headers);

          if (res.data?.status === "success") {
            setStatus("Login successful!");
            navigate('/admin/settings');

              } else {
                alert(res?.data?.message);
              }

    }

    useEffect(() => {
        getexchangetoken();
      }, [search]);
    return (
        <>
        <div className="adminmainpagelayout">
            <h5>{status}</h5>
            <br />
        </div>
            
        </>
        
    )
}

export default TwitterCallback